/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetModifiableTransactionLimitsForTheUserAccount200Response
 */
export interface GetModifiableTransactionLimitsForTheUserAccount200Response {
    /**
     * 
     * @type {string}
     * @memberof GetModifiableTransactionLimitsForTheUserAccount200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetModifiableTransactionLimitsForTheUserAccount200Response
     */
    'limitType': GetModifiableTransactionLimitsForTheUserAccount200ResponseLimitTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetModifiableTransactionLimitsForTheUserAccount200Response
     */
    'limit': number | null;
}

export const GetModifiableTransactionLimitsForTheUserAccount200ResponseLimitTypeEnum = {
    dailyLimit: 'DAILY_LIMIT',
    monthlyLimit: 'MONTHLY_LIMIT',
    transactionLimit: 'TRANSACTION_LIMIT'
} as const;

export type GetModifiableTransactionLimitsForTheUserAccount200ResponseLimitTypeEnum = typeof GetModifiableTransactionLimitsForTheUserAccount200ResponseLimitTypeEnum[keyof typeof GetModifiableTransactionLimitsForTheUserAccount200ResponseLimitTypeEnum];


